<section class="reserve-study-edit-section">
    <div class="row">
        <div class="col-md-6">
            <h2 class="section-header">{{ 'RESERVE STUDY' | terminology | async }} HISTORY</h2>
        </div>
        <div class="col-md-6 text-end margin-bottom-10" *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']">
            <button class="btn btn-success" (click)="addReserveStudyModal.show()">
                Add {{ 'reserve study' | terminology | async }}
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="grid-container" *ngIf="reserveStudies?.length > 0">
                <dx-data-grid
                    #dxReserveStudyHistoryDataGrid
                    id="reserveStudyHistoryDataGrid"
                    [dataSource]="reserveStudies"
                    [showColumnLines]="false"
                    [showRowLines]="true"
                    [showBorders]="false"        
                    (onRowPrepared)="dxGridRowPrepared($event)"            
                    (onContextMenuPreparing)="onContextMenuPreparing($event)">

                    <dxo-data-grid-load-panel [enabled]="true"></dxo-data-grid-load-panel>
                                
                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="date" dataType="date" caption="Date" alignment="left" cellTemplate="dateTemplate"></dxi-data-grid-column>
                    <div *dxTemplate="let cellData of 'dateTemplate'">
                        {{cellData.row.data.date | date}}
                    </div>  
                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="reserveStudyTypeName"  caption="Type of Study" alignment="left"></dxi-data-grid-column>
                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="providerName" caption="Provider" alignment="left"></dxi-data-grid-column>       
                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="inspectionDate" caption="Inspection Date" alignment="left" cellTemplate="inspectionDateTemplate"></dxi-data-grid-column>          
                    <div *dxTemplate="let cellData of 'inspectionDateTemplate'">
                        <div *ngIf="cellData.row.data.reserveStudyTypeId !== 1">
                            N/A
                        </div>
                        <div *ngIf="cellData.row.data.reserveStudyTypeId === 1">
                            {{cellData.row.data.inspectionDate | date}}
                        </div>
                    </div>
                    <dxi-data-grid-column cssClass="dx-grid-cell" dataField="cost" caption="Cost" alignment="left" cellTemplate="costTemplate"></dxi-data-grid-column>   
                    <div *dxTemplate="let cellData of 'costTemplate'">
                        <div *ngIf="cellData.row.data.cost !== null">
                            {{cellData.row.data.cost | currency:'USD':'symbol-narrow':'1.0-2'}}
                        </div>
                    </div>
                    <dxi-data-grid-column *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']" cssClass="dx-grid-cell" alignment="right" cellTemplate="menu">
                        <div *dxTemplate="let cellData of 'menu'">                
                            <dx-button
                                id="btnShowActionMenu"
                                hint="Action Menu"
                                [hoverStateEnabled]="false"
                                [activeStateEnabled]="false"
                                stylingMode="text" 
                                type="normal" 
                                icon="overflow" 
                                (onClick)="showActionMenu($event)">
                            </dx-button>                  
                        </div>
                    </dxi-data-grid-column>

                    <dxo-data-grid-scrolling rowRenderingMode="virtual"> </dxo-data-grid-scrolling>

                    <dxo-data-grid-paging [pageSize]="10"> </dxo-data-grid-paging>

                    <dxo-data-grid-pager
                        [visible]="true"
                        [allowedPageSizes]="allowedPageSizes"
                        [displayMode]="'compact'"
                        [showPageSizeSelector]="true"
                        [showInfo]="true"
                        [showNavigationButtons]="true">
                    </dxo-data-grid-pager>
                </dx-data-grid>
            </div>
        </div>

    </div>
</section>

<sp-add-update-reserve-study-modal #addReserveStudyModal (onConfirm)="onAdd($event)">
</sp-add-update-reserve-study-modal>

<sp-add-update-reserve-study-modal #updateReserveStudyModal [reserveStudy]="reserveStudyToUpdate"
    (onConfirm)="onUpdate($event)"></sp-add-update-reserve-study-modal>

<sp-modal [title]="'Remove ' + (('Reserve Study' | terminology | async) || 'Reserve Study')" (confirm)="onDelete()" confirmButtonText="Remove" isWarning="true"
    #deleteReserveStudyModal>
    <div class="row">
        <div class="col-md-10">
            <div>Do you want to remove the {{ 'reserve study' | terminology | async }} completed on <strong>{{reserveStudyToDelete?.date |
                    date}}</strong> by <strong>{{reserveStudyToDelete?.providerName}}</strong>?</div>
        </div>
    </div>
</sp-modal>